export default {
  '--divider-color': 'rgba(255, 255, 255, 0.2)',
  '--divider-text-color': '#aaa'
};